import React from "react";
import { AlertCircleIcon } from "lucide-react";
type FormFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error?: string;
  optional?: boolean;
  type?: "text" | "email" | "tel";
  autoComplete?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  multiline?: boolean;
  hint?: string;
};
export function FormField({
  id,
  label,
  value,
  onChange,
  error,
  optional = false,
  type = "text",
  autoComplete,
  inputMode,
  multiline = false,
  hint
}: FormFieldProps) {
  const errorId = `${id}-error`;
  const hintId = `${id}-hint`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(" ") || undefined;
  const fieldClass = `mt-1.5 block w-full rounded-md border-2 bg-white px-4 text-ink placeholder:text-slate ${error ? "border-crimson" : "border-slate"}`;
  return <div data-id="element-92" data-mp="14jc3b9x1ghyb">
      <label htmlFor={id} className="block text-label font-bold text-ink" data-id="element-93" data-mp="14j2ehpnqcgu7">
        {label}
        {optional && <span className="font-normal text-slate" data-id="element-94" data-mp="zlu62gsdvr65"> (optional)</span>}
      </label>
      {hint && <p id={hintId} className="mt-1 text-meta text-slate" data-id="element-95" data-mp="1ej2x19drysxc">
          {hint}
        </p>}
      {multiline ? <textarea id={id} name={id} rows={4} value={value} onChange={onChange} aria-invalid={error ? true : undefined} aria-describedby={describedBy} className={`${fieldClass} py-3`} data-id="element-96" data-mp="19hnfhrat34jp" /> : <input id={id} name={id} type={type} value={value} onChange={onChange} autoComplete={autoComplete} inputMode={inputMode} required={!optional} aria-required={!optional} aria-invalid={error ? true : undefined} aria-describedby={describedBy} className={`${fieldClass} min-h-[56px]`} data-id="element-97" data-mp="1x7rhju8ciw8l" />}
      {error && <p id={errorId} className="mt-2 flex items-start gap-2 text-meta font-semibold text-crimson" data-id="element-98" data-mp="2e941v0lbailt">
          <AlertCircleIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0" data-id="element-99" data-mp="2j8qh1fkpa8x9" />
          {error}
        </p>}
    </div>;
}